export const I18n = {
    'en': {
        filter: 'Apply filter',
        resetFilters: 'Reset filters',
        searchPlaceholder: 'Search...',
        dateFrom: 'From Date',
        dateTo: 'To Date',

        loans: 'Loans',
        loanOrders: 'Loan orders',
        order: 'Order',
        phoneNumber: 'Phone number',
        price: 'Price',
        product: 'Product',
        numberOfProducts: 'Number of products',
        company: 'Company',
        store: 'Store',
        salesman: 'Salesman',
        bank: 'Bank',
        status: 'Status',
        extraInfo: 'Extra info',
        created: 'Created',
        numberOfPayments: 'Number of payments',

        loanOrderCreation: 'Creation of a loan order',
        creditors: 'Creditors',
        createOrder: 'Create order',
        cancel: 'Cancel',
        confirm: 'Confirm',
        return: 'Return',

        refundedAmount: 'Refunded amount',
        returnProduct: 'Return product',
        returnMoneyToCard: 'Return money to card',
        sum: 'Sum',
        enterTheSum: 'Enter the sum',

        back: 'Back',
        refresh: 'Refresh',
        error: 'Error',

        settings: 'Settings',
        name: 'Name',
        value: 'Value',
        bankPropsInitialised: 'Bank props initialised',
        maxNumberOfPayments: 'Max number of payments',
        notSpecified: 'Not specified',
        chooseCompany: 'Choose a company',

        invalidUserError: 'Only retail users connected to a single sales point can create an order',
        userHasToBeConnectedToSingleStore: 'User has to be connected to a single sales point. Contact your administrator',
        contactUsToAccessThis: "Contact info@hankuper.com to access this functionality",
    },
    'ru': {
        filter: 'Застосувати фільтри',
        resetFilters: 'Скинути фільтри',
        searchPlaceholder: 'Пошук...',
        dateFrom: 'C дати',
        dateTo: 'По дату',

        loans: 'Кредити',
        loanOrders: "Заявки на кредити",
        order: 'Заявка',
        phoneNumber: 'Номер телефону',
        price: 'Вартість',
        product: 'Товар',
        numberOfProducts: 'Кількість товарів',
        company: 'Компанія',
        store: 'Магазин',
        salesman: 'Продавець',
        bank: 'Банк',
        status: 'Статус',
        extraInfo: 'Додаткова інформація',
        created: 'Створений',
        numberOfPayments: 'Кількість платежів',

        loanOrderCreation: 'Створення заявки на видачу кредиту',
        creditors: 'Кредитори',
        createOrder: 'Створити заявку',
        cancel: 'Скасувати',
        confirm: 'Підтвердити',
        return: 'Повернути',

        refundedAmount: 'Повернута сума',
        returnProduct: 'Повернути товар',
        returnMoneyToCard: 'Повернути гроші на картку',
        sum: 'Сума',
        enterTheSum: 'Введіть суму',

        back: 'Назад',
        refresh: 'Оновити',
        error: 'Помилка',

        settings: 'Налаштування',
        name: 'Назва',
        value: 'Значення',
        bankPropsInitialised: 'Реквізити банку ініціалізовано',
        maxNumberOfPayments: 'Максимальна кількість платежів',
        notSpecified: 'Не задано',
        chooseCompany: 'Оберіть компанію',

        invalidUserError: 'Створити заявку може тільки продавець, прив\'язаний до одного магазину',
        userHasToBeConnectedToSingleStore: 'Продавець повинен бути прив\'язаний до одного магазину. Зверніться до вашого адміністратора',
        contactUsToAccessThis: "Зв'яжіться з info@hankuper.com, щоб отримати доступ до цього функціоналу",
    },
};


// WEBPACK FOOTER //
// ./src/I18n/components/loan/index.js